import { c as _c } from "react/compiler-runtime";
import type { Entry } from "contentful";
import Image from "next/image";
import Link from "next/link";
import { isEntry } from "@/lib/contentful/guards";
import type { TypeCardSkeleton } from "@/types/contentful/generated";
import { ContentfulHelper } from "@/utils/ContentfulHelper";
export type CardEntry = Entry<TypeCardSkeleton, undefined, string>;
interface Props {
  card: CardEntry;
}
export default function CardItem(t0) {
  const $ = _c(20);
  const {
    card
  } = t0;
  const {
    heading,
    description,
    url,
    isNewTab,
    image
  } = card.fields;
  const imageEntry = isEntry(image) ? image : undefined;
  let t1;
  if ($[0] !== imageEntry) {
    t1 = imageEntry ? ContentfulHelper.parseContentfulContentImage(imageEntry.fields.media) : null;
    $[0] = imageEntry;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const contentImage = t1;
  let t2;
  if ($[2] !== contentImage || $[3] !== heading) {
    t2 = contentImage && <div className="relative w-full aspect-square overflow-hidden rounded-lg"><Image src={contentImage.src} alt={contentImage.alt || heading} fill={true} sizes="(min-width: 768px) 25vw, 100vw" className="object-cover" /></div>;
    $[2] = contentImage;
    $[3] = heading;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== heading) {
    t3 = <h3 className="heading-sm">{heading}</h3>;
    $[5] = heading;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== description) {
    t4 = description && <p className="text-base font-normal leading-6 text-foreground">{description}</p>;
    $[7] = description;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t3 || $[10] !== t4) {
    t5 = <div className="flex w-full flex-col gap-2">{t3}{t4}</div>;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t2 || $[13] !== t5) {
    t6 = <div className="flex h-full w-full flex-col items-center gap-4 rounded-lg bg-background p-4 shadow-md">{t2}{t5}</div>;
    $[12] = t2;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const inner = t6;
  if (url) {
    const t7 = isNewTab ? "_blank" : undefined;
    const t8 = isNewTab ? "noopener noreferrer" : undefined;
    let t9;
    if ($[15] !== inner || $[16] !== t7 || $[17] !== t8 || $[18] !== url) {
      t9 = <Link className="no-underline! h-full" href={url} target={t7} rel={t8}>{inner}</Link>;
      $[15] = inner;
      $[16] = t7;
      $[17] = t8;
      $[18] = url;
      $[19] = t9;
    } else {
      t9 = $[19];
    }
    return t9;
  }
  return inner;
}